import React, { useState } from "react";

import { Plus, X } from "lucide-react";

import { Button } from "./ui/button";
import { Input } from "./ui/input";

const MeetingManager = ({ meetings, onAdd, onUpdate, onRemove }) => {
  const [newMeeting, setNewMeeting] = useState({
    number: "",
    date: "",
    attendees: [],
  });

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <Input
          placeholder="Meeting Number"
          value={newMeeting.number}
          onChange={(e) =>
            setNewMeeting({ ...newMeeting, number: e.target.value })
          }
        />

        <Input
          type="date"
          value={newMeeting.date}
          onChange={(e) =>
            setNewMeeting({ ...newMeeting, date: e.target.value })
          }
        />
      </div>

      <Button
        onClick={() => {
          if (newMeeting.number && newMeeting.date) {
            onAdd(newMeeting);
            setNewMeeting({ number: "", date: "", attendees: [] });
          }
        }}
      >
        <Plus className="h-4 w-4 mr-2" />
        Add Meeting
      </Button>

      <div className="space-y-2">
        {meetings.map((meeting, index) => (
          <div
            key={index}
            className="flex justify-between items-center p-2 bg-secondary rounded"
          >
            <span>
              {meeting.number} - {meeting.date}
            </span>

            <Button variant="ghost" size="sm" onClick={() => onRemove(index)}>
              <X className="h-4 w-4" />
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MeetingManager;
